const generateInputField = ({
  id: fieldId,
  fieldType,
  name,
  label,
  value: givenValue,
  defaultValue,
  placeholder,
  options,
  isDisabled = true,
  columnClass = 'sub-section-content-column',
}) => {
  const column = document.createElement('div')
  column.className = `${columnClass} ehv-element`
  column.id = name
  column.style.minWidth = '25rem'

  let inputHtml = ''
  let value = givenValue || defaultValue || undefined

  if (fieldType === 'CurrencyInput') {
    inputHtml = `
        <span class="ant-input-affix-wrapper ${isDisabled ? 'ant-input-affix-wrapper-disabled' : ''} ant-input-affix-wrapper-readonly Input">
          <input ${isDisabled ? 'readonly' : ''} class="ant-input ${isDisabled ? 'ant-input-disabled' : ''} impowerx-currency-input" inputmode="decimal" ${isDisabled ? 'disabled' : ''} type="text" value="${value || defaultValue}" name="${name}" data-field-id="${fieldId}" placeholder="${placeholder}" />
          <span class="ant-input-suffix">€</span>
        </span>
      `
  } else if (fieldType === 'PercentageInput') {
    inputHtml = `
        <div class="ant-input-number InputNumber Input ${isDisabled ? 'ant-input-number-disabled' : ''}">
          <div class="ant-input-number-handler-wrap">
            <span unselectable="on" role="button" aria-label="Increase Value" aria-disabled="false" class="ant-input-number-handler ant-input-number-handler-up">
              <span role="img" class="anticon">
                <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <path d="M5 0H3V3H0V5H3V8H5V5H8V3H5V0Z" fill="black"></path>
                </svg>
              </span>
            </span>
            <span unselectable="on" role="button" aria-label="Decrease Value" aria-disabled="false" class="ant-input-number-handler ant-input-number-handler-down">
              <span role="img" class="anticon">
                <svg width="8" height="2" viewBox="0 0 8 2" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <rect x="8" width="2" height="8" transform="rotate(90 8 0)" fill="black"></rect>
                </svg>
              </span>
            </span>
          </div>
          <div class="ant-input-number-input-wrap">
            <input autocomplete="off" role="spinbutton" class="ant-input-number-input" ${isDisabled ? 'disabled' : ''} value="" name="${name}" placeholder="0.00" />
            <span class="suffix suffix-with-controls">%</span>
          </div>
        </div>
      `
  } else if (fieldType === 'RadioGroup') {
    inputHtml = `
        <div class="ant-radio-group ant-radio-group-outline RadioGroup SwitchElement justify-content-unset" name="${name}" data-field-id="${fieldId}">
          ${options
        .map(
          (option) => `<div class="radio-group-option">
                <label class="ant-radio-wrapper ${isDisabled ? 'ant-radio-wrapper-disabled' : ''} ant-radio-wrapper-in-form-item">
                  <span class="ant-radio ${isDisabled ? 'ant-radio-disabled' : ''} ${value === option.value ? 'ant-radio-checked' : ''}">
                    <input type="radio" ${isDisabled ? 'disabled' : ''} class="ant-radio-input" value="${option.value}" onclick="toggleRadioCheck(this)">
                    <span class="ant-radio-inner"></span>
                  </span>
                  <span>${option.label}</span>
                </label>
              </div>`
        )
        .join('')}
        </div>
      `
    column.classList.add('RadioGroupInput')
  } else if (fieldType === 'CheckboxGroup') {
    const checkedOptions = value ? value.split('|') : []

    inputHtml = `
      <div class="ant-checkbox-group" name="${name}" data-field-id="${fieldId}">
        ${options
        .map(
          (option) => `<label class="ant-checkbox-wrapper ${isDisabled ? 'ant-checkbox-wrapper-disabled' : ''} ant-checkbox-wrapper-in-form-item ant-checkbox-group-item">
          <span class="ant-checkbox ${isDisabled ? 'ant-checkbox-disabled' : ''} ${checkedOptions.includes(option.value) ? 'ant-checkbox-checked' : ''}">
            <input type="checkbox" ${isDisabled ? 'disabled' : ''} class="ant-checkbox-input" value="${option.value}" onclick="handleCheckboxClick(this)" />
            <span class="ant-checkbox-inner"></span>
          </span>
          <span style="font-size: 16px;">${option.label}</span>
        </label>`
        )
        .join('')}
      </div>
    `

    column.classList.add('CheckboxGroupInput')
    column.style.height = 'unset'
  } else if (fieldType === 'DropdownMenu') {
    inputHtml = `
      <div class="ant-select ant-select-in-form-item Select ant-select-single ant-select-show-arrow ant-select-show-search ${isDisabled ? 'read-only ant-select-disabled' : ''} impowerx-select" disabled="${isDisabled}" name="${name}" data-field-id="${fieldId}" style="position: relative; overflow: visible;">
        <div class="ant-select-selector">
          <span class="ant-select-selection-search">
            <input type="search" ${isDisabled ? 'disabled' : ''} autocomplete="off" class="ant-select-selection-search-input" role="combobox" aria-haspopup="listbox" aria-owns="rc_select_0_list" aria-autocomplete="list" aria-controls="rc_select_0_list" aria-activedescendant="rc_select_0_list_0" value="" id="rc_select_0" aria-expanded="false" placeholder="${!value ? (placeholder || '') : ''}">
          </span>
          <span class="ant-select-selection-item" title="${value || ''}">${value || ''}</span>
        </div>

        <span class="ant-select-arrow" unselectable="on" aria-hidden="true" style="user-select: none;">
          <span role="img" class="anticon">
            <svg width="10" height="5" viewBox="0 0 10 5" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0L5 5L10 0H0Z" fill="#000000"></path>
            </svg>
          </span>
        </span>
      </div>

      <div style="position: absolute; top: 0px; left: 0px; width: 100%;" class="dropdown-wrapper">
        <div>
          <div class="ant-select-dropdown ant-select-dropdown-placement-bottomRight ant-select-dropdown-hidden impowerx-select-dropdown"
            style="z-index: 2000; width: 100%; left: 0px; top: 45px;">
            <div>
              <div role="listbox" id="rc_select_3_list" style="height: 0px; width: 0px; overflow: hidden;">
                <div role="option" id="rc_select_3_list_2" aria-selected="false">C</div>
                <div role="option" id="rc_select_3_list_3" aria-selected="false">D</div>
              </div>
              <div class="rc-virtual-list" style="position: relative;">
                <div class="rc-virtual-list-holder" style="max-height: 256px; overflow-y: hidden; overflow-anchor: none;">
                  <div>
                    <div class="rc-virtual-list-holder-inner" style="display: flex; flex-direction: column;">
                      ${options
        .map(
          (
            option
          ) => `<div aria-selected="true" class="ant-select-item ant-select-item-option ant-select-item-option-selected impowerx-select-menu-item" title="${option.label}">
                        <div class="ant-select-item-option-content">
                          <div class="select-menu-item">${option.label}</div>
                        </div>
                      </div>`
        )
        .join('')}
                    </div>
                  </div>
                </div>
                <div class="rc-virtual-list-scrollbar"
                  style="width: 8px; top: 0px; bottom: 0px; right: 0px; position: absolute; display: none;">
                  <div class="rc-virtual-list-scrollbar-thumb"
                    style="width: 100%; height: 128px; top: 0px; left: 0px; position: absolute; background: rgba(0, 0, 0, 0.5); border-radius: 99px; cursor: pointer; user-select: none;">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    `

    column.classList.add('Select')
  } else if (fieldType === 'DatePicker') {
    inputHtml = `
      <div class="MuiFormControl-root MuiTextField-root DatePicker ${isDisabled ? 'read-only' : ''}"  name="${name}" data-field-id="${fieldId}">
        <div
          class="MuiInputBase-root MuiInput-root MuiInput-underline MuiInputBase-formControl MuiInput-formControl MuiInputBase-adornedEnd ${isDisabled ? 'Mui-disabled Mui-disabled' : ''}">
          <input aria-invalid="false" type="text" ${isDisabled ? 'disabled="" placeholder=""' : 'placeholder="TT.MM.JJJJ"'}
            class="MuiInputBase-input MuiInput-input MuiInputBase-inputAdornedEnd ${isDisabled ? 'Mui-disabled Mui-disabled' : ''}" value="${value || defaultValue || ''}">
          <div class="MuiInputAdornment-root MuiInputAdornment-positionEnd">
            <button class="MuiButtonBase-root MuiIconButton-root" tabindex="-1" type="button" ${isDisabled ? 'disabled=""' : ''} style="${isDisabled ? 'display: none;' : ''}">
              <span class="MuiIconButton-label">
                <svg class="MuiSvgIcon-root" focusable="false" viewBox="0 0 24 24" aria-hidden="true">
                  <path
                    d="M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"></path>
                  <path fill="none" d="M0 0h24v24H0z"></path>
                </svg>
              </span>
              ${isDisabled ? '' : '<span class="MuiTouchRipple-root"></span>'}
            </button>
          </div>
        </div>
      </div>

      ${generateDatePickerModal()}
    `

    column.classList.add('DatePicker')
  } else if (fieldType === 'ContactComboBox') {
    const selectedContactOption = (options || []).find((opt) => String(opt.value) === String(value))
    const displayContactLabel = selectedContactOption ? selectedContactOption.label : ''

    inputHtml = `
      <div class="contact-combobox" style="position: relative;">
        <div class="ant-select ant-select-in-form-item ContactComboBox Select ant-select-single ant-select-show-arrow ant-select-show-search ${isDisabled ? 'read-only ant-select-disabled' : ''} impowerx-select" disabled="${isDisabled}" name="${name}" data-field-id="${fieldId}" onclick="(function(root){ if(root.classList.contains('ant-select-disabled')||root.classList.contains('read-only')||root.getAttribute('disabled')==='true'){return;} var input=root.querySelector('.ant-select-selection-search-input'); var sel=root.querySelector('.ant-select-selection-item'); var prev = sel && sel.textContent ? sel.textContent.trim() : ''; if(input){ input.value=''; input.setAttribute('placeholder', prev || '${placeholder || ''}'); } if(sel){ sel.textContent=''; sel.setAttribute('title',''); } var list=(root.parentElement||root).querySelector('.contact-combobox-list'); if(list){ Array.prototype.forEach.call(list.querySelectorAll('.contact-combobox-item'), function(el){ el.style.display=''; }); } if(input && typeof input.focus==='function'){ input.focus(); } })(this)">
          <div class="ant-select-selector">
            <span class="ant-select-selection-search">
              <input type="search" ${isDisabled ? 'disabled' : ''} autocomplete="off" class="ant-select-selection-search-input" role="combobox" aria-haspopup="listbox" aria-autocomplete="list" value="" placeholder="${!value ? (placeholder || '') : ''}" oninput="(function(i){var root=i.closest('.contact-combobox'); if(!root){return;} var list=root.querySelector('.contact-combobox-list'); if(!list){return;} var q=i.value.toLowerCase(); Array.prototype.forEach.call(list.querySelectorAll('.contact-combobox-item'), function(el){el.style.display = el.textContent.toLowerCase().indexOf(q) !== -1 ? '' : 'none';});})(this)">
            </span>
            <span class="ant-select-selection-item" title="${displayContactLabel}">${displayContactLabel}</span>
          </div>

          <span class="ant-select-arrow" unselectable="on" aria-hidden="true" style="user-select: none;">
            <span role="img" class="anticon">
              <svg width="10" height="5" viewBox="0 0 10 5" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0L5 5L10 0H0Z" fill="#000000"></path>
              </svg>
            </span>
          </span>
        </div>

        <div style="position: absolute; top: 0px; left: 0px; width: 100%;" class="dropdown-wrapper">
          <div>
            <div class="ant-select-dropdown ant-select-dropdown-placement-bottomRight ant-select-dropdown-hidden impowerx-select-dropdown"
              style="z-index: 2000; width: 100%; left: 0px; top: 45px;">
              <div class="rc-virtual-list" style="position: relative;">
                <div class="rc-virtual-list-holder" style="max-height: 256px; overflow-y: auto; overflow-anchor: none;">
                  <div>
                    <div class="rc-virtual-list-holder-inner contact-combobox-list" style="display: flex; flex-direction: column;">
                      ${options
        .map(
          (option) => `
                            <div class="ant-select-item ant-select-item-option contact-combobox-item${String(option.value) === String(value) ? ' ant-select-item-option-selected' : ''}" data-value="${option.value}" title="${option.label}">
                              <div class="ant-select-item-option-content">
                                <div class="select-menu-item">${option.label}</div>
                              </div>
                            </div>`
        )
        .join('')}
                    </div>
                  </div>
                </div>
                <div class="rc-virtual-list-scrollbar"
                  style="width: 8px; top: 0px; bottom: 0px; right: 0px; position: absolute; display: none;">
                  <div class="rc-virtual-list-scrollbar-thumb"
                    style="width: 100%; height: 128px; top: 0px; left: 0px; position: absolute; background: rgba(0, 0, 0, 0.5); border-radius: 99px; cursor: pointer; user-select: none;">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    `

    column.classList.add('ContactComboBox')
  } else if (fieldType === 'FileInput') {
    inputHtml = fileInputHtml(fieldId, isDisabled)
  }

  column.innerHTML = `
      <div class="${fieldType}">
        <div class="ant-row ant-form-item ant-form-item-with-help" style="row-gap: 0px;">
          <div class="ant-col ant-form-item-label">
            <label title="">
              <span>${label}</span>
            </label>
          </div>
          <div class="ant-col ant-form-item-control">
            <div class="ant-form-item-control-input">
              <div class="ant-form-item-control-input-content">
                ${inputHtml}
              </div>
            </div>
            <div class="ant-form-item-explain ant-form-item-explain-connected">
              <div role="alert" class="" style=""></div>
            </div>
          </div>
        </div>
      </div>
    `

  return column
}

const generateSubSection = (newSubSection) => {
  return `
  <div class="sub-section" id="${newSubSection}">
    <div class="sub-section-header ">
      <div class="sub-section-title">${newSubSection.replace('_', ' ')}</div>
    </div>

    <div class="sub-section-content">
      <div class="sub-section-content-row"></div>
    </div>
  </div>
  `
}

const generateSidebarLink = (newSubSection) => {
  return `
    <div class="Link sub-link impowerx-sidebar-link" id="sidebar-${newSubSection}">
      <div class="link-row level2  arrow-placeholder">
        <div class="link-title" role="button" tabindex="-1">${newSubSection.replace('_', ' ')}</div>
      </div>
    </div>
  `
}

const fileInputButtonHtml = (fileInputId = 'file-input', isDisabled = false) => {
  return `
    <button type="button" class="ant-btn ant-btn-default Button file-input-label" ${isDisabled ? 'disabled' : ''}><span role="img" class="anticon"><svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 4.41009V15.0001H10V4.41009L13.29 7.71009L14.71 6.29009L9 0.590088L3.29 6.29009L4.71 7.71009L8 4.41009ZM0 18.0001V20.0001H18V18.0001H0Z" fill="black"></path></svg></span><span>Dateien auswählen</span></button>
    <input id="${fileInputId}" ${isDisabled ? 'disabled' : ''} class="file-input impower-x-file-input" type="file" accept=".pdf,.doc,.xlsx,.jpg,.png" value="" multiple="multiple">
  `
}

const fileInputHtml = (fileInputId = 'file-input', isDisabled = false) => {
  return `
    <label style="font-weight: 500;" for="${fileInputId}" class="file-input-label" tabindex="0">
      <span style="padding-right: 1.6rem; padding-left: 0.4rem;" role="img" class="anticon">
        <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 4.41009V15.0001H10V4.41009L13.29 7.71009L14.71 6.29009L9 0.590088L3.29 6.29009L4.71 7.71009L8 4.41009ZM0 18.0001V20.0001H18V18.0001H0Z" fill="black"></path></svg>
      </span>Datei auswählen...</label>
    <input id="${fileInputId}" ${isDisabled ? 'disabled' : ''} class="file-input impower-x-file-input" type="file" accept=".pdf,.doc,.xlsx,.jpg,.png" value="" multiple="multiple">
  `
}
const generateFileInput = (fileInputId = 'file-input', isDisabled = false, isButton = false) => {
  const newfileElement = document.createElement('div')
  newfileElement.classList.add('impower-x')
  if (isDisabled) {
    newfileElement.setAttribute('disabled', true)
  }
  newfileElement.innerHTML = isButton ? fileInputButtonHtml(fileInputId, isDisabled) : fileInputHtml(fileInputId, isDisabled)

  if (isButton) {
    const button = newfileElement.querySelector('.file-input-label')
    const input = newfileElement.querySelector(`#${fileInputId}`)
    if (button && input) {
      button.addEventListener('click', (e) => {
        e.preventDefault()
        e.stopPropagation()
        input.click()
      })
    }
  }
  return newfileElement
}
